module.exports = __webpack_public_path__ + "static/media/arrow-small.7698dc69.svg";